var _style, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _polygon, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _circle, _circle2, _path61, _ellipse, _path62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelegation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#BDD0FB;}\n\t.st5{opacity:0.43;fill:#FFFFFF;}\n\t.st6{fill:#91B3FA;}\n\t.st7{fill:url(#SVGID_2_);}\n\t.st8{opacity:0.37;fill:#FFFFFF;}\n\t.st9{fill:url(#SVGID_3_);}\n\t.st10{fill:url(#SVGID_4_);}\n\t.st11{fill:url(#SVGID_5_);}\n\t.st12{fill:url(#SVGID_6_);}\n\t.st13{fill:url(#SVGID_7_);}\n\t.st14{fill:url(#SVGID_8_);}\n\t.st15{fill:url(#SVGID_9_);}\n\t.st16{fill:url(#SVGID_10_);}\n\t.st17{fill:url(#SVGID_11_);}\n\t.st18{fill:url(#SVGID_12_);}\n\t.st19{fill:url(#SVGID_13_);}\n\t.st20{fill:url(#SVGID_14_);}\n\t.st21{fill:url(#SVGID_15_);}\n\t.st22{fill:url(#SVGID_16_);}\n\t.st23{fill:url(#SVGID_17_);}\n\t.st24{fill:url(#SVGID_18_);}\n\t.st25{fill:url(#SVGID_19_);}\n\t.st26{fill:url(#SVGID_20_);}\n\t.st27{fill:url(#SVGID_21_);}\n\t.st28{fill:url(#SVGID_22_);}\n\t.st29{fill:url(#SVGID_23_);}\n\t.st30{fill:url(#SVGID_24_);}\n\t.st31{fill:url(#SVGID_25_);}\n\t.st32{fill:url(#SVGID_26_);}\n\t.st33{fill:url(#SVGID_27_);}\n\t.st34{fill:url(#SVGID_28_);}\n\t.st35{fill:url(#SVGID_29_);}\n\t.st36{fill:url(#SVGID_30_);}\n\t.st37{fill:url(#SVGID_31_);}\n\t.st38{fill:url(#SVGID_32_);}\n\t.st39{fill:url(#SVGID_33_);}\n\t.st40{fill:url(#SVGID_34_);}\n\t.st41{fill:url(#SVGID_35_);}\n\t.st42{fill:#7D97F4;}\n\t.st43{fill:url(#SVGID_36_);}\n\t.st44{fill:url(#SVGID_37_);}\n\t.st45{fill:url(#SVGID_38_);}\n\t.st46{fill:url(#SVGID_39_);}\n\t.st47{fill:url(#SVGID_40_);}\n\t.st48{fill:url(#SVGID_41_);}\n\t.st49{fill:url(#SVGID_42_);}\n\t.st50{fill:url(#SVGID_43_);}\n\t.st51{fill:#666694;}\n\t.st52{fill:url(#SVGID_44_);}\n\t.st53{fill:url(#SVGID_45_);}\n\t.st54{fill:url(#SVGID_46_);}\n\t.st55{fill:url(#SVGID_47_);}\n\t.st56{fill:url(#SVGID_48_);}\n\t.st57{fill:url(#SVGID_49_);}\n\t.st58{fill:url(#SVGID_50_);}\n\t.st59{fill:url(#SVGID_51_);}\n\t.st60{fill:url(#SVGID_52_);}\n\t.st61{fill:url(#SVGID_53_);}\n\t.st62{fill:url(#SVGID_54_);}\n\t.st63{opacity:0.78;fill:#FFFFFF;}\n\t.st64{fill:url(#SVGID_55_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 3710,
    height: 3710
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3516.0156,
    y1: 3928.2551,
    x2: 1129.7651,
    y2: 964.6816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2859.5,2759.5c-54.8,57.7-106.7,94.9-147.6,124.3c-481.7,345.6-1051.6,244.9-1172.7,220.3 c-178.9-36.3-524.6-106.5-774.6-400.5c-378.2-444.7-319.3-1145.4-25.9-1607.9c53.7-84.6,337.1-554.2,913.1-629.5 c348.6-45.6,755,46.3,1049.3,292.9C3318.9,1276.7,3274.9,2322.3,2859.5,2759.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3010.7,1141.9c-3.7-15.6-25.9-15.8-29.9-0.3c-38.4,149.8-151.5,539.6-334.2,749.1 c-297.5,341.2-488.3,888.8-286.6,1165.6C2360,3056.4,3416.3,2837.3,3010.7,1141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2986.1,1355.1c-0.3,4.9-0.9,8.9-1.3,13.2l-1.6,12.7l-3.6,25.4c-2.5,16.9-5.3,33.8-8,50.7 c-5.6,33.7-11.7,67.4-18.1,101c-12.9,67.2-27.5,134-43.2,200.6c-15.6,66.6-33,132.8-51.9,198.6 c-18.9,65.8-38.7,131.3-60.7,196.2c-43.7,129.8-94.5,257.3-154.2,380.7c-30.5,61.4-62.5,122-98,180.6 c-35.9,58.3-74.4,115.2-116.8,169c-0.9,1.2-2.6,1.4-3.8,0.4c-1.1-0.9-1.4-2.5-0.5-3.7l0,0c40.1-55.2,77.2-112.4,111.4-171.4 c34.4-58.9,65.3-119.7,94.6-181.2c29.3-61.6,56.1-124.3,81.4-187.6c25.3-63.3,48-127.6,70.4-192.1 c44.1-129.1,81.3-260.5,114.9-392.8c16.6-66.2,32-132.7,46.1-199.5c7.1-33.4,13.9-66.8,20.3-100.4l9.2-50.4l4.3-25.2l2-12.6 c0.6-4.1,1.3-8.6,1.7-12.2l0.1-0.6c0.2-1.5,1.5-2.5,2.9-2.4C2985.1,1352.4,2986.2,1353.6,2986.1,1355.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2487.1,815.4c-7.7-13.3-28-7.4-27.5,7.9c5.6,147.9,8.3,536.1-102.1,778.2 c-179.8,394.1-205.4,948.3,55.2,1147.1C2412.7,2748.5,3321.6,2259.5,2487.1,815.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2522.8,1017.5c1.1,4.6,1.6,8.4,2.4,12.5l2,12.1l3.7,24.3c2.3,16.2,4.4,32.4,6.5,48.7 c4,32.5,7.7,65,11,97.6c6.5,65.1,11.3,130.4,15.1,195.8c3.9,65.4,5.9,130.8,6.6,196.3c0.6,65.5,0.3,131-2.2,196.5 c-4.7,130.9-16.5,261.7-37.5,391.2c-11.2,64.6-24.1,128.9-40.7,192.4c-17,63.3-36.8,125.9-61,186.8c-0.5,1.3-2.1,2-3.4,1.5 c-1.3-0.5-2-2-1.5-3.3l0,0c21.7-61.6,40.1-124.2,55.4-187.6c15.5-63.4,27.2-127.6,37.3-192c10-64.4,17.5-129.3,23.5-194.2 c6-65,9.2-130.1,12.1-195.3c5.3-130.4,3.5-261.1-1.8-391.5c-2.8-65.2-6.9-130.4-12.1-195.5c-2.6-32.6-5.4-65.1-8.7-97.6 l-5.3-48.7l-2.9-24.3l-1.6-12.1c-0.6-4-1.1-8.2-1.8-11.7l-0.1-0.6c-0.3-1.4,0.7-2.8,2.1-3 C2521.1,1015.3,2522.4,1016.2,2522.8,1017.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 2261.386,
    y1: 1909.6332,
    x2: 816.9695,
    y2: 3158.313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M555.9,2968.6v-851.8c0-111.9,89.9-203,201.8-204.2c335.9-3.7,1028.5-3.8,1595.3,43.9 c77.3,6.5,137.5,69.9,140.3,147.5l53,823.5c3.9,108.9-82.2,199.9-191.2,202L751,3160C643.9,3162.1,555.9,3075.8,555.9,2968.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M750.4,2209c-1.4,72.5,0.7,187.5,2.5,261.8c0.9,38.7,34.9,68.1,73.3,63.6l276.4-32.4 c36.8-4.3,62.8-38.3,57.3-74.9l-33.9-226.3c-4.8-32.1-32.4-55.9-64.9-55.9h-245C780.4,2144.9,751.1,2173.3,750.4,2209z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1472.8,2637.9l230.6,24.9c32.3,3.5,59.8-23.1,57.4-55.5l-50.4-685.9c-96.7-3.1-192-5.3-284-6.9v671.7 C1426.4,2612.8,1446.4,2635.1,1472.8,2637.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1567.3,2519.1c0.7,12.3,10.9,21.8,23.1,21.8c0.5,0,0.9,0,1.4,0c12.8-0.7,22.6-11.7,21.8-24.5l-34.8-598.6 c-15.6-0.4-31.1-0.7-46.5-1.1L1567.3,2519.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1215.364,
    y1: 1535.7167,
    x2: -1208.6149,
    y2: 2048.6882,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M878.3,2425.1c-4,0-7.5-3.1-7.7-7.2l-12-188.5c-0.3-4.3,3-7.9,7.2-8.2c4.5-0.3,7.9,3,8.2,7.2l12,188.5 c0.3,4.3-3,7.9-7.2,8.2C878.6,2425.1,878.4,2425.1,878.3,2425.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -1187.8871,
    y1: 1535.3549,
    x2: -1181.1379,
    y2: 2048.3254,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M902.9,2425.1c-4.2,0-7.6-3.3-7.7-7.5l-6.3-192.2c-0.1-4.3,3.2-7.9,7.5-8c4.9-0.2,7.8,3.2,8,7.5 l6.3,192.2c0.1,4.3-3.2,7.9-7.5,8C903.1,2425.1,903,2425.1,902.9,2425.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -1156.2629,
    y1: 1534.9387,
    x2: -1149.5138,
    y2: 2047.91,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M935.9,2425.1c-4.1,0-7.5-3.2-7.7-7.4c-1.5-31.6-9-189.3-9-192.5c0-4.3,3.5-7.7,7.7-7.7 c4.2,0,7.7,3.4,7.7,7.7c0.1,4.2,5.9,127.3,9,191.9c0.2,4.3-3.1,7.9-7.4,8.1C936.1,2425.1,936,2425.1,935.9,2425.1z  M934.6,2225.2h0.2H934.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -1102.9224,
    y1: 1534.2375,
    x2: -1096.1731,
    y2: 2047.208,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M987.4,2432.8c-8.3,0-15.1-6.6-15.4-14.9c-6.5-186.2-5.4-190.4-4.6-193.1c2.2-8.3,10.8-13.1,19-10.9 c7.6,2.1,12.3,9.4,11.3,17c-0.5,11.2,3,119.5,5.3,185.9c0.3,8.5-6.4,15.7-14.9,16C987.8,2432.8,987.6,2432.8,987.4,2432.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -1066.754,
    y1: 1533.761,
    x2: -1060.0049,
    y2: 2046.7308,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1020.9,2425.1c-4.3,0-7.7-3.5-7.7-7.7v-188.5c0-4.3,3.5-7.7,7.7-7.7c4.3,0,7.7,3.5,7.7,7.7v188.5 C1028.7,2421.6,1025.2,2425.1,1020.9,2425.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -1044.203,
    y1: 1533.4636,
    x2: -1037.4537,
    y2: 2046.4336,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1048,2425.1c-4.2,0-7.6-3.4-7.7-7.6c-1.5-65.5-4.9-172.5-8-185.4c-1.4-2.4-1.3-5.5,0.3-8 c2.3-3.6,7.1-4.6,10.7-2.2c4.2,2.8,8.2,5.4,12.5,195.3c0.1,4.3-3.3,7.8-7.5,7.9H1048z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -1256.1793,
    y1: 1536.2533,
    x2: -1249.4302,
    y2: 2049.2234,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M836.7,2442.2c-8.2,0-15-6.4-15.4-14.7l-10.3-198c-0.4-8.5,6.1-15.8,14.6-16.2 c8.1-0.6,15.8,6.1,16.2,14.6l10.3,198c0.4,8.5-6.1,15.8-14.6,16.2C837.2,2442.2,836.9,2442.2,836.7,2442.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 2636.9167,
    y1: 2132.28,
    x2: 936.0157,
    y2: 1194.0833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M825.2,1802v-598.2c0-78.6,63.2-142.5,141.7-143.4c235.9-2.6,722.3-2.7,1120.4,30.8 c54.3,4.6,96.6,49.1,98.5,103.6l37.2,578.3c2.8,76.5-57.7,140.4-134.2,141.9l-1126.6,21.4C886.9,1937.9,825.2,1877.3,825.2,1802 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M961.8,1268.6c-1,50.9,0.5,131.7,1.7,183.8c0.6,27.1,24.5,47.8,51.4,44.7l194.1-22.8 c25.9-3,44.1-26.9,40.2-52.6l-23.8-158.9c-3.4-22.6-22.8-39.3-45.6-39.3h-172C982.8,1223.5,962.3,1243.5,961.8,1268.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1469.1,1569.8l161.9,17.5c22.7,2.4,42-16.2,40.3-39l-35.4-481.7c-67.9-2.2-134.8-3.7-199.4-4.8v471.7 C1436.5,1552.1,1450.5,1567.8,1469.1,1569.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1535.4,1486.3c0.5,8.7,7.7,15.3,16.2,15.3c0.3,0,0.6,0,1,0c9-0.5,15.8-8.2,15.3-17.2l-24.4-420.4 c-10.9-0.3-21.8-0.5-32.7-0.8L1535.4,1486.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -141.5107,
    y1: -1405.4285,
    x2: -276.5031,
    y2: -986.9521,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1051.6,1420.3c-2.8,0-5.2-2.2-5.4-5.1l-8.4-132.4c-0.2-3,2.1-5.6,5.1-5.8c3.2-0.2,5.6,2.1,5.8,5.1 l8.4,132.4c0.2,3-2.1,5.6-5.1,5.8C1051.8,1420.3,1051.7,1420.3,1051.6,1420.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.4154,
    y1: -1399.9142,
    x2: -259.4077,
    y2: -981.4382,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1068.8,1420.3c-2.9,0-5.3-2.3-5.4-5.2l-4.4-134.9c-0.1-3,2.3-5.5,5.2-5.6c3.5-0.2,5.5,2.3,5.6,5.2 l4.4,134.9c0.1,3-2.3,5.5-5.2,5.6C1069,1420.3,1068.9,1420.3,1068.8,1420.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -104.2943,
    y1: -1393.4275,
    x2: -239.2864,
    y2: -974.9517,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1092,1420.3c-2.9,0-5.3-2.3-5.4-5.2c-1.1-22.2-6.3-133-6.3-135.2c0-3,2.4-5.4,5.4-5.4 c3,0,5.4,2.4,5.4,5.4c0.1,2.9,4.2,89.4,6.3,134.7c0.1,3-2.2,5.5-5.2,5.7C1092.2,1420.3,1092.1,1420.3,1092,1420.3z  M1091.1,1279.9h0.1H1091.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -69.9089,
    y1: -1382.3374,
    x2: -204.9014,
    y2: -963.8607,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1128.2,1425.7c-5.8,0-10.6-4.6-10.8-10.5c-4.6-130.7-3.8-133.7-3.3-135.6c1.6-5.8,7.6-9.2,13.3-7.6 c5.3,1.5,8.6,6.6,7.9,11.9c-0.3,7.9,2.1,83.9,3.7,130.6c0.2,6-4.5,11-10.5,11.2C1128.5,1425.7,1128.3,1425.7,1128.2,1425.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.9675,
    y1: -1374.926,
    x2: -181.9598,
    y2: -956.4499,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1151.7,1420.3c-3,0-5.4-2.4-5.4-5.4v-132.4c0-3,2.4-5.4,5.4-5.4c3,0,5.4,2.4,5.4,5.4v132.4 C1157.2,1417.9,1154.7,1420.3,1151.7,1420.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.6646,
    y1: -1370.3218,
    x2: -167.657,
    y2: -951.8452,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1170.7,1420.3c-2.9,0-5.4-2.4-5.4-5.3c-1-46-3.5-121.2-5.6-130.2c-1-1.7-0.9-3.9,0.2-5.6 c1.6-2.5,5-3.2,7.5-1.6c3,1.9,5.8,3.8,8.8,137.1c0.1,3-2.3,5.5-5.3,5.6H1170.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -166.4713,
    y1: -1413.4744,
    x2: -301.4635,
    y2: -994.9985,
    gradientTransform: "matrix(1 0 0 1 2077.291 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1022.3,1432.4c-5.7,0-10.5-4.5-10.8-10.3l-7.2-139c-0.3-6,4.3-11.1,10.3-11.4 c5.7-0.4,11.1,4.3,11.4,10.3l7.2,139c0.3,6-4.3,11.1-10.3,11.4C1022.7,1432.4,1022.5,1432.4,1022.3,1432.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1574.7455,
    y1: 1417.4663,
    x2: 600.9554,
    y2: 2663.3455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1491.9,1897.8l-39.6,21.3c-47.5,28.9-90,44.2-128.3,49.9c-119.4,17.9-197.3-57.4-255.3-103.2 c-76.6-60.4-136.2-31-136.2-31l81.7,155.9c122,115,247,89.5,325.9,52.2c50.2-23.7,81.6-52.2,81.6-52.2 C1511.5,1937.3,1491.9,1897.8,1491.9,1897.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.6766,
    y1: 1743.032,
    x2: 1138.2059,
    y2: 2444.7522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1608.6,1953.6c-2.6-8.5-8.8-15.4-17.1-18.7l-80.4-32.3c0,0-1.2-10.3,17-17.3c18.2-7,13.9-27.4,13.9-27.4 s-24.9,11.3-61.3,29.3c-20.8,10.3-32.5,28.4-38.7,42.1l20.7,27.2c49.5,14.9,99.7,17.7,150.2,11.8L1608.6,1953.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.6381,
    y1: 3016.0667,
    x2: -12.646,
    y2: 3191.1199,
    gradientTransform: "matrix(-1 0 0 1 990.5665 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M915.1,3089.7c0,0-6.1,34.6-9.1,68.9c-1.2,13.4,9.2,25,22.6,25.6c45.7,1.9,143.3,5.6,178.4,4 c5.3-0.2,8.7-5.6,6.8-10.5l0,0c-1.6-4.1-4.8-7.4-8.8-9.3l-161.3-74.2L915.1,3089.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 3935.8562,
    y1: 3089.5332,
    x2: 3988.3337,
    y2: 3089.5332,
    gradientTransform: "matrix(1 0 0 1 -3025.8091 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M910,3069.3l4.9,41.4c0,0,28.3,13.2,47.6-1.7l-11.7-46.2L910,3069.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 3694.8369,
    y1: 1694.7997,
    x2: 3956.6697,
    y2: 2832.8638,
    gradientTransform: "matrix(1 0 0 1 -3025.8091 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M902.2,2263.1c-2.1,11.2,3.8,587.6,60.4,833.4c0.9,4,6.8,11.9,4.8,15.3c-4.9,8.4-41,6-61.4,6.7 c-6.3,0.2-9.7-7.2-11.5-13.5c-16.2-57-93.6-342.8-103.7-615.8c-11.3-305,0-10.4,0-10.4l-5-193.3L902.2,2263.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.8907,
    y1: 3025.1843,
    x2: 238.2547,
    y2: 3198.6021,
    gradientTransform: "matrix(-1 0 0 1 990.5665 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M729.5,3107.7c0,0-9.7,17.5-19.2,64c-1.7,8.4,4.2,16.4,12.7,17.3c15.1,1.5,38.3,3.4,56.9,3.3 c8.6-0.1,15.3-7.5,14.2-16c-2.1-17-8.5-44.8-28.3-66.5L729.5,3107.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 3746.7239,
    y1: 3086.842,
    x2: 3792.0344,
    y2: 3086.842,
    gradientTransform: "matrix(1 0 0 1 -3025.8091 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M720.9,3054.5l11.5,62.7c0,0,11.4,8.4,33.8,2.3l-5.5-67.4L720.9,3054.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 3607.7659,
    y1: 1694.5605,
    x2: 3872.9705,
    y2: 2847.28,
    gradientTransform: "matrix(1 0 0 1 -3025.8091 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M693.3,2285.6c-46.3,291.4,6.6,742.5,25.6,826.5c1.2,5.1,5.1,9.1,10.1,9.9c8.5,1.5,22.4,2.7,36.2-1.5 c4.7-1.4,8.1-5.9,8.3-11c2.5-67.9-2-484.4,41.1-649c2.2-8.3,7.1-15.6,13.8-20.6l70.9-57.8l1.3-124.6L693.3,2285.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 957.9053,
    y1: 1905.1006,
    x2: 530.4299,
    y2: 2364.0737
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M958.3,1818.1c-121.9-2-256.4,32-256.4,32c-30,174.8-17.9,368.5-11.7,432.3c1.3,13.1-5.7,26.9,7.3,29 c63.8,10.3,164.1-0.2,195.2-9.2c11.4-3.3,9.5-15.4,11.9-27c20.9-100.3,80.7-321.6,80.7-321.6c29,37.3,69.9,89.5,130.4,103.4 c-30.8-35.7,28.3-110.7,22-137.5C1083,1857.9,995.9,1818.7,958.3,1818.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6132,
    y1: 1701.9642,
    x2: 823.8658,
    y2: 1935.9513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M834.9,1719.1l-38.8,112.2c-0.6,1.9,0.1,3.9,1.8,4.9c10.6,5.8,48.7,22.7,94.6-6.4c4.8-3,8-8,8.8-13.6 l12.6-97.1H834.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -3015.1382,
    y1: 218.2783,
    x2: -2853.147,
    y2: 508.5123,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 2100.5264 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M919.3,1615.2c0,0,42.6,80.2,37.1,112.6c-5.5,32.4-58.3,30.1-104.4,3.8l-32.2-86.6L919.3,1615.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -2586.5886,
    y1: 883.5499,
    x2: -2555.5901,
    y2: 1060.3562,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 2100.5264 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M854.1,1689c1.9-0.8,2.6-3.1,1.4-4.8c-3.4-5.2-9.8-15.8-11.9-25.2c0,0-7.7-4.9,19.5-11.4 c14.8-3.5,41-6.5,52.5-17.1c12.9-11.9-10.9-34.4-20.9-40.4c-13.2-8-29.2-12.7-44.1-8.7c-7.2,1.9-13.7,5.8-20.1,9.6 c-10.9,6.5-22.2,13.3-29.1,23.9c-4.5,6.9-6.8,14.9-9,22.8c-3.1,11.4-5.9,23-5.4,34.8c1.4,31.3,38.2,59.4,67.7,62.8 c2.4,0.3,4.3-2.1,3.5-4.4l-12.1-35.1c-0.6-1.6,0.2-3.4,1.8-4.1L854.1,1689z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -3046.1169,
    y1: 235.5644,
    x2: -2884.126,
    y2: 525.7984,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 2100.5264 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M858.9,1694c0,0-30.3-20.8-32.5-3.3c-2.2,17.5,27.3,25.4,41.9,18.8L858.9,1694z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.8434,
    y1: 1596.413,
    x2: 1025.8287,
    y2: 1677.4083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M934.8,1595.6c-62.2-117.5-223.5-10.8-148.5,88.3C842.1,1646.7,905.2,1591.5,934.8,1595.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 780.0263,
    y1: 1577.0461,
    x2: 1032.0114,
    y2: 1658.0414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M837.6,1645.3l111.7-3.5c2.8-0.1,5.4-1.7,6.8-4.1c10-18.1,24.7-29.6,43-35.9c2.3-0.8,1.8-4.2-0.6-4.4 l-68.5-4.7c-0.1,0-0.2,0-0.2,0c-34.1,2.6-64.4,23.2-93.2,50.1C835.6,1643.8,836.3,1645.4,837.6,1645.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 837.3339,
    y1: 1792.8041,
    x2: 409.8588,
    y2: 2251.7769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M715.7,2028c68.2-76.6,61.3-135.6-15.7-178c0,0-127.7,86.7-148.6,196.7c24.1,1.8,68,8.1,111,29.7 C671.8,2024.5,715.7,2028,715.7,2028z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 5647.3848,
    y1: 2132.0874,
    x2: 5981.8877,
    y2: 2132.0874,
    gradientTransform: "matrix(1 0 0 1 -5098.915 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M864,2106.9c0,0-143.3,81-191.7,11.8c-10-14.4-12.4-28.6-10-42.2c-43-21.7-86.9-28-111-29.7 c-6.3,33.2-3,68.4,16.5,104.1c84.7,155,315.1-8.6,315.1-8.6L864,2106.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 816.0974,
    y1: 2194.8906,
    x2: 1278.4471,
    y2: 1867.5336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M846.8,2209.3l78.2-273.2c0.9-3.1,3.5-5.4,6.7-5.7c14.2-1.7,55.2-6.3,102.7-10.3 c57.1-4.8,123.4-8.7,163.1-5.4c5.6,0.5,9,6.4,6.5,11.5c-22.5,45.6-115.2,231.1-161.7,291.8c-1.5,2-3.9,3.2-6.5,3.2l-181.5-1.7 C849.1,2219.5,845.3,2214.4,846.8,2209.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1042.5,1896.4l56.7-9.4c3-0.5,5.5,2.4,4.5,5.3l-5.6,17c-0.5,1.5-1.8,2.6-3.3,2.8l-54.6,7.3 c-2.8,0.4-5.2-2.2-4.5-5l3.5-14.9C1039.6,1897.9,1040.9,1896.7,1042.5,1896.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1000,1944.4l4.7-24.3c0.5-2.4,2.5-4.3,5-4.5l114.5-11.6c3.9-0.4,6.9,3.1,6,6.9l-7.3,30.3 c-0.6,2.4-2.7,4.2-5.2,4.3l-111.9,5.6C1002.2,1951.3,999.4,1948,1000,1944.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 5957.0522,
    y1: 2097.0151,
    x2: 6061.2642,
    y2: 2097.0151,
    gradientTransform: "matrix(1 0 0 1 -5098.915 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M865.7,2143.3c0,0-10.9-44.8-6.5-60.7c4.4-15.9,12.9-36.3,41.3-31.8c28.4,4.5,61.9,16.5,61.9,16.5 s-1.7,20.7-23.3,14l13.4,10.4c0,0-1.9,16.6-20.1,7.7l12.4,13.7c0,0-7.8,13.6-21.2,4.9C910.1,2109.3,903.7,2148.7,865.7,2143.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 850.1314,
    y1: 1475.9476,
    x2: 813.0085,
    y2: 1752.6823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M820.3,1972.8c-8.9,0.7-84.6,3.1-84.6,3.1l3.1,76.2l39.2,22.1l42.4-22.1V1972.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.2521,
    y1: 2022.2477,
    x2: 966.3653,
    y2: 1543.0251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "826.3,1972.8 735.8,1975.9 732.1,2005.1 779.2,2017.4 829.2,1995.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 9062.4502,
    y1: 3202.489,
    x2: 9169.4316,
    y2: 3202.489,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M3179.3,3164.8c0,0,11.9,18.7,14.9,71.2c0.3,4.9-3.6,9.1-8.5,9.1h-93c-3.7,0-6.4-3.7-5.2-7.2 c5.4-16.1,21.9-55.4,58.7-77.9L3179.3,3164.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 9073.3027,
    y1: 3152.7761,
    x2: 9116.6904,
    y2: 3152.7761,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M3183.4,3129.2l-5.3,44.1c-0.5,3.8-3.4,6.8-7.2,7.3c-5.1,0.6-12.5,1-19.7-0.2 c-6.5-1.1-11.2-6.9-11.2-13.5v-42.6L3183.4,3129.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 9289.958,
    y1: 3200.7786,
    x2: 9457.8164,
    y2: 3200.7786,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M2949.3,3159.9c0,0,17.8,27.7,17.4,65.6c-0.1,8.9-7.6,16.1-16.5,16.1h-144.4c-6.8,0-9.5-8.7-4-12.6 c27.3-19.2,81-55,119.9-69.1H2949.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 9292.5088,
    y1: 3133.51,
    x2: 9335.6572,
    y2: 3133.51,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M2964.2,3112.3l-11.2,54.5c-1.3,6.1-7.2,10.2-13.3,8.8c-3.7-0.8-8-2.4-12.7-5.3c-4.4-2.8-6.7-8-5.8-13.2 l11.6-66L2964.2,3112.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 9046.3438,
    y1: 2750.7668,
    x2: 9340.5049,
    y2: 2750.7668,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M3162.8,2355.2c0,0,39,34.4,46.3,75.8c7.3,41.4-20.8,713.7-20.8,713.7s-39,6.5-59.1-5.7 c0,0-23.8-436.4-42-537.2c0,0-95,452-121.4,533.7c0,0-37.6,4.6-49.7-2.6c0,0,24.9-585.9,56.2-690.1L3162.8,2355.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3088.4,2587.3c-0.3,0-0.7,0-1-0.1c-2.1-0.5-3.3-2.7-2.8-4.8l16.6-63.5c0.2-1,0.8-1.8,1.7-2.3l35.8-23 c1.8-1.2,4.2-0.6,5.4,1.2c1.2,1.8,0.6,4.2-1.2,5.4l-34.5,22.1l-16.2,62.1C3091.7,2586.1,3090.1,2587.3,3088.4,2587.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 10062.1191,
    y1: 2322.1565,
    x2: 9720.3457,
    y2: 2155.1833,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M2777.9,1966.7C2942.1,1953,2985,1987,2985,1987l-78.9,124.6c0,0-161.3-3.2-276.9-92.3 c21.6-23.3,36.7-49,46.3-69.1C2705.3,1962.6,2739.6,1969.8,2777.9,1966.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 9581.2031,
    y1: 1870.0566,
    x2: 9741.5654,
    y2: 1870.0566,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M2520.8,1725.7c0.2-5.3,7.4-6.7,9.6-1.9l20.9,44.7c4,8.6,5.3,18.3,3.7,27.7l-7.3,26 c-2.2,12.7,1.1,25.7,9.2,35.7c19.2,24.1,60.2,68,118.6,92.3c-9.6,20-24.7,45.8-46.3,69.1c-42.4-32.7-78.7-76.9-98.5-136.8 c-9.5-2.9-15.9-11.9-15.5-21.8L2520.8,1725.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 9399.1592,
    y1: 2153.7468,
    x2: 9311.377,
    y2: 2985.0962,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M2723.8,2038.9c57.8-62.3,167.9-90.4,231.6-102c27.9-5.1,55.4,10.5,65.3,37.1 c28.7,77.1,106.7,277.7,121.8,312.2c12.4,28.3,25.4,55.9,33.6,73.2c4.9,10.3,0.6,22.7-9.7,27.6 c-53.6,25.8-150.1,55.1-189.2,66.5c-8.6,2.5-17.2-4-17.2-12.9c0-7.6-2.1-15.1-6-21.6L2806,2172.1 c-92.3,102.4-173.2,111.8-235.3,89.3c10.4-32.3,17.3-64.6,20.6-97C2683,2148.7,2723.8,2038.9,2723.8,2038.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -13167.3281,
    y1: 18090.9316,
    x2: -13366.4424,
    y2: 18229.3008,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M2413.7,2129.1l30-17.5c53.6,36.8,110.8,59.1,147.5,52.8c-3.3,32.4-10.1,64.7-20.6,97 C2488.8,2231.9,2413.7,2129.1,2413.7,2129.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -13145.4736,
    y1: 18122.3652,
    x2: -13344.5879,
    y2: 18260.7324,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M2271.2,2135.4c18.7-10.2,74-18.9,74-18.9s63.6-37.2,82-44.6c15.2-6.1,21.8,16.7,23.5,24.6 c0.4,1.6,0.5,2.6,0.5,2.6l-2.4,15.1l-64.3,28.6c-13.8,6.1-28.9,8.3-43.9,6.4l-68.6-9c-1.1-0.1-2-1-2.2-2.1 C2269.7,2137,2270.2,2135.9,2271.2,2135.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 9554.5039,
    y1: 1644.4967,
    x2: 9218.917,
    y2: 2261.1038,
    gradientTransform: "matrix(-1 0 0 1 12256.6602 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M2867.8,1822.5l49.2,120.1c0,0-56.6,39.2-102.1,35.4l-24.6-108L2867.8,1822.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 7534.5112,
    y1: 9218.7842,
    x2: 7386.2012,
    y2: 9414.9863,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 14280.0889 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M2784.6,1740.6c-1.1,1.6-35.6,126.2-35.6,126.2l71.6,18.2l50.2-113.2 C2870.8,1771.8,2803.5,1713.9,2784.6,1740.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 7421.2451,
    y1: 9266.1133,
    x2: 7598.4038,
    y2: 9266.1133,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 14280.0889 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M2843.9,1789l-21.8,61.7c-0.3,0.8-0.7,1.5-1.1,2.2c-3,4.2-14.2,17.9-27.5,5.6 c-12.1-11.2-23.3-21.2-33.6-23.1c-4.6-0.8-9.1,2-10.4,6.6c-3.1,11.3-9.7,37-12,60.1c-0.5,4.7,2.8,8.9,7.4,9.8 c14,2.7,43.6,7.4,68.4,5.7c3.4-0.2,6.3-2.2,7.7-5.3c6.8-14.9,27.7-60.1,35.5-71.8c7.3-11,25.2-10.7,32.7-10 c2.5,0.2,4.9-0.6,6.7-2.2c6.6-5.7,19-20.4,1.5-38c-3.7-3.7-3.6-9.6,0.2-13.2c7.5-7.1,15.6-19.7,3-35.3 c-12.8-15.9-29.6-13.3-40-9.6c-4.2,1.5-8.7-0.2-11-4.1c-1.3-2.2-3.5-3.8-7.5-3.5c-5.3,0.5-9.7-3.9-9.6-9.2 c0.2-10.2-3.5-23-21.1-28.5c-31.3-9.7-50.8,20.5-52.7,43c-1.9,22.5,32.6,31.2,52.8,29.6c15.4-1.2,26.9,14.1,31.5,21.5 C2844.5,1783.5,2844.8,1786.4,2843.9,1789z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 7317.2944,
    y1: 9374.1611,
    x2: 7436.252,
    y2: 9252.1143,
    gradientTransform: "matrix(-0.817 -0.5767 -0.5767 0.817 14280.0889 -1428.4956)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M2848.2,1862.8c0,0,5.1-39.1,21.3-41c16.3-1.9,32.1,11.5,15.9,33.4 C2865.3,1882.5,2848.2,1862.8,2848.2,1862.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 2134.1089,
    y1: 1808.8696,
    x2: 1647.7352,
    y2: 2630.5098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 2165,
    cy: 1756.7,
    r: 402.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 2652.1047,
    y1: 987.5735,
    x2: 2438.3672,
    y2: 1325.0546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 2165,
    cy: 1756.7,
    r: 389.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1849.9,1591c-1.1,0-2.3-0.3-3.3-0.9c-3.6-2-4.9-6.5-2.9-10.2c67.3-122,195.5-194.7,334.7-189.6 c22.2,0.8,44.4,3.6,65.9,8.4c4,0.9,6.6,4.9,5.7,8.9c-0.9,4-4.9,6.6-8.9,5.7c-20.6-4.5-41.9-7.2-63.2-8 c-133.5-4.9-256.5,64.8-321,181.9C1855.4,1589.7,1852.7,1591.1,1849.9,1591z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -611.9024 2053.7471)",
    className: "st63",
    cx: 2173.1,
    cy: 1765.5,
    rx: 329.3,
    ry: 329.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1750.4608,
    y1: 2473.8213,
    x2: 2087.9414,
    y2: 1920.3533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M2131.9,2009l1.3-35.8c-37.3-2.9-73.9-13-99.7-25.4c-9.2-4.4-13.6-15.1-10.6-24.9l10.3-33 c3.8-12.1,17.3-18,28.8-12.6c25.6,11.9,57.4,21.7,92.1,22.9c36,1.3,63.2-9.9,64.1-34.9c0.8-22.5-19.4-36.7-68.9-51.9 c-70.6-22.1-120.6-55-118.4-117.8c2.1-56.7,45.1-98.4,117.4-107.4l1.3-35.8c0.4-11.5,10.1-20.5,21.6-20.1l21,0.8 c11.5,0.4,20.5,10.1,20.1,21.6l-1.2,32.2c34.5,2.6,59.4,9.5,79.1,17.2c10.1,4,15.3,15.2,12.1,25.5l-9.5,30.5 c-3.7,11.8-16.6,17.8-28,13c-18.1-7.6-43.8-15.8-77.6-17c-42.7-1.6-55.5,15.7-56.1,31.5c-0.7,19.5,24.4,33.8,79.2,52.9 c78.4,26.7,110.1,60.8,107.9,119.9c-2,54.2-44,101.5-122.4,110.9l-1.5,40.1c-0.4,11.5-10.1,20.5-21.6,20.1l-21-0.8 C2140.5,2030.2,2131.5,2020.5,2131.9,2009z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegation);
export default __webpack_public_path__ + "static/media/delegation.36668279deb8dd34e2942f4696ada939.svg";
export { ForwardRef as ReactComponent };